import { getPathVariables, normalizePath, slugify } from "../url/index.js";
function recursivePathMap(itemList, itemsAtLevel, parentPath, pathMap = {}) {
  const nameCount = {};
  itemsAtLevel.forEach((uid) => {
    const item = itemList[uid];
    if (item) {
      const name = parentPath ? `${parentPath}/${slugify(item.title)}` : slugify(item.title);
      pathMap[uid] = nameCount[name] ? `${name}-${nameCount[name]}` : name;
      nameCount[name] = nameCount[name] ? nameCount[name] + 1 : 1;
      if (item.children) {
        recursivePathMap(itemList, item.children, pathMap[uid], pathMap);
      }
    }
  });
  return pathMap;
}
function findFirstPage(items, children, pageKey = "Page") {
  for (const uid of children) {
    const item = items[uid];
    if (item?.type === pageKey) return item.uid;
    if (item?.children) {
      const firstPage = findFirstPage(items, item.children, pageKey);
      if (firstPage) return firstPage;
    }
  }
  return void 0;
}
function templateOrderMatches(template, requiredOrder) {
  const pathKeys = getPathVariables(template);
  const strippedOrder = requiredOrder.filter((key) => pathKeys.includes(key));
  const strippedPathKeys = pathKeys.filter((key) => strippedOrder.includes(key));
  return strippedPathKeys.every((key, idx) => key === strippedOrder[idx]);
}
function validateDocsPathTemplate({
  base,
  type,
  multipleVersions,
  multipleLocales
}) {
  const issues = [];
  const sanitized = normalizePath(base.replaceAll(" ", ""));
  const keys = getPathVariables(sanitized);
  if (keys.includes("version") && keys.includes(type) && keys.indexOf("version") >= keys.indexOf(type)) {
    issues.push(
      `The {{version}} key must be before the {{${type}}} key in your path template.`
    );
  }
  if (multipleVersions && !keys.includes("version"))
    issues.push("With multiple versions the {{version}} key must be included.");
  if (multipleLocales && !keys.includes("locale"))
    issues.push(
      "If you have more than one locale the {{locale}} key must be a part of your path template."
    );
  if (type !== "flat-guide" && !keys.includes(type)) {
    issues.push(
      type === "guide" ? "The {{guide}} key must be present if there are multiple guides in any version." : `The {{${type}}} key must be present in the path template.`
    );
  }
  return {
    path: sanitized,
    withoutGuide: normalizePath(sanitized.replace("{{guide}}", "")),
    withoutVersion: normalizePath(sanitized.replace("{{version}}", "")),
    withoutLocale: normalizePath(sanitized.replace("{{locale}}", "")),
    withoutVersionAndLocale: normalizePath(
      sanitized.replace("{{version}}", "").replace("{{locale}}", "")
    ),
    issues,
    error: issues.length > 0
  };
}
function getFallbackTemplates(numVersions) {
  const flattenVersion = numVersions === 1;
  return {
    reference: flattenVersion ? "{{reference}}" : "{{version}}/{{reference}}",
    guide: flattenVersion ? "{{guide}}" : "{{version}}/{{guide}}"
  };
}
export {
  findFirstPage,
  getFallbackTemplates,
  recursivePathMap,
  templateOrderMatches,
  validateDocsPathTemplate
};
//# sourceMappingURL=utility.js.map
